import React, { PropsWithChildren } from "react";

function SearchIcon(props: PropsWithChildren<any>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      fill="none"
      viewBox="0 0 20 21"
      {...props}
    >
      <path
        fill="#522398"
        d="M19.727 17.805l-3.907-3.907c-.195-.156-.43-.273-.664-.273h-.625a8.145 8.145 0 001.719-5C16.25 4.172 12.578.5 8.125.5 3.633.5 0 4.172 0 8.625a8.119 8.119 0 008.125 8.125 8.073 8.073 0 005-1.719v.664c0 .235.078.47.273.664l3.868 3.868c.39.39.976.39 1.328 0l1.093-1.094c.391-.352.391-.938.04-1.328zm-11.602-4.18c-2.773 0-5-2.227-5-5 0-2.734 2.227-5 5-5 2.734 0 5 2.266 5 5 0 2.773-2.266 5-5 5z"
      ></path>
    </svg>
  );
}

export default React.memo(SearchIcon);
